import { Row, Col, Card } from 'react-bootstrap';
import '../../scss/components/shared/PageTitle.scss';

const PageTitle = (props) => {
    return (
        <Row>
            <Col sm={12}>
                <Card>
                    <Card.Body>
                        <h1 className="title">{props.title}</h1>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}

export default PageTitle;